// minor optimization, see https://tigerabrodi.blog/regex-performance-optimization-in-javascript
const splitStringPattern = /[A-Z][a-z]+|[\d]+/g;

export function humanizeEnumValue(value?: string): string | undefined {
  if (!value) {
    return value;
  }
  return value.match(splitStringPattern)?.join(" ");
}
